import { Component, OnInit, ViewChild } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
declare var $: any;
import * as moment from 'moment';
import { GroupService } from 'src/app/api/departure/group.service';
import { ScheduleService } from 'src/app/api/departure/schedule.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import HC_heatmap from 'highcharts/modules/heatmap';
import HC_more from 'highcharts/highcharts-more';

// Inicializa los módulos
HC_exporting(Highcharts);
moment.locale('es');
HC_more(Highcharts);
HC_heatmap(Highcharts);

@Component({
  selector: 'app-record-guide-extends',
  templateUrl: './record-guide-extends.component.html',
  styleUrls: ['./record-guide-extends.component.css']
})
export class RecordGuideExtendsComponent implements OnInit {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  private thisComponent: RecordGuideExtendsComponent;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  chart: Highcharts.Chart | undefined;
  updateFlag: boolean = false; // Flag para forzar la actualización

  date_range: any = null;
  tour: any = null;
  bookings: any = [];

  // variables para datos
  start_range: any = moment()
    .subtract(8, 'days')
    .startOf('day'); // 7 días antes de ayer
  end_range: any = moment()
    .subtract(1, 'day')
    .startOf('day'); // Ayer

  guideSelected: any = null;
  items_tours_grouped: any = null;
  items_transport: any = null;

  // variables para calendario de salidas
  HighchartsHeatmap: typeof Highcharts = Highcharts;
  chartOptionsHeatmap: Highcharts.Options = {};
  chartHeatmap: Highcharts.Chart | undefined;
  updateFlagHeatmap: boolean = false;
  start_range_calendar: any = moment().startOf('month');
  end_range_calendar: any = moment().endOf('month');

  data_calendar: any = [
    // { description: 'laguna azul', date_departure: '02-07-2025' }
  ];

  constructor(
    private groupService: GroupService,
    private scheduleService: ScheduleService
  ) {
    this.thisComponent = this;
  }

  ngOnInit() {
    // this.generateCalendar();
    // this.generateGraph();
    this.generateGraphicCalendar();
  }

  init(data: any) {
    // inicializar datos
    this.items_tours_grouped = [];
    this.items_transport = [];
    this.generateCalendarRange();
    // ========
    this.guideSelected = data;
    this.LoadingModalComponent.show();
    let val_params =
      'start_range=' +
      this.start_range.format('YYYY-MM-DD') +
      '&end_range=' +
      this.end_range.format('YYYY-MM-DD') +
      '&guide_id=' +
      this.guideSelected.id;

    this.scheduleService.summaryCalendarByGuide(val_params).subscribe({
      next: (data: any) => {
        this.prepareToursWithGaps(data.results);
        this.LoadingModalComponent.hide();
      }
    });

    let val_params_transport =
      'start_range=' +
      moment()
        .subtract(30, 'days')
        .startOf('day')
        .format('YYYY-MM-DD') +
      '&end_range=' +
      moment()
        .subtract(1, 'day')
        .startOf('day')
        .format('YYYY-MM-DD') +
      '&guide_id=' +
      this.guideSelected.id;

    this.scheduleService.summaryToursByGuide(val_params_transport).subscribe({
      next: (data: any) => {
        this.items_transport = data.results_transport.slice(0, 10);
      }
    });
    this.getDataViewCalendar();
  }

  prepareToursWithGaps(data: any[]) {
    const start = this.start_range.clone();
    const end = this.end_range.clone();

    const result: any[] = [];

    // Agrupar los registros por fecha
    const groupedByDate: { [key: string]: any[] } = {};

    data.forEach((item: any) => {
      const dateKey = moment(item.date_departure).format('YYYY-MM-DD');

      // Asignar el nuevo campo "transport"
      item.transport = item.transport_data?.owner ?? '-';

      if (!groupedByDate[dateKey]) {
        groupedByDate[dateKey] = [];
      }
      groupedByDate[dateKey].push(item);
    });

    // Recorrer el rango desde la fecha más reciente hacia atrás
    const current = end.clone();
    while (current.isSameOrAfter(start)) {
      const dateKey = current.format('YYYY-MM-DD');
      if (groupedByDate[dateKey]) {
        result.push(...groupedByDate[dateKey]); // insertar todos los de esa fecha
      } else {
        // result.push({
        //   date_departure: dateKey,
        //   description: '-',
        //   transport: '-',
        //   nro_pax: '-' // por si también usas nro_pax
        // });
      }
      current.subtract(1, 'day');
    }

    this.items_tours_grouped = result;
  }

  generateCalendarRange() {
    const selectedMoment = moment(); // mes actual
    // Setear valores por defecto en las variables de rango
    this.start_range_calendar = selectedMoment.clone().startOf('month');
    this.end_range_calendar = selectedMoment.clone().endOf('month');

    // Inicializar el datepicker
    setTimeout(() => {
      // Asignar por defecto el valor al input
      ($('#date_calendar') as any).val(selectedMoment.format('YYYY-MM'));
      ($('#date_calendar') as any)
        .datepicker({
          format: 'yyyy-mm',
          startView: 1,
          minViewMode: 1,
          language: 'es',
          autoclose: true
        })
        .on('changeDate', (e: any) => {
          const selectedMoment = moment(e.date);

          this.start_range_calendar = selectedMoment.clone().startOf('month');
          this.end_range_calendar = selectedMoment.clone().endOf('month');

          this.getDataViewCalendar();
        });
    }, 150);
  }

  getDataViewCalendar() {
    this.LoadingModalComponent.show();
    let val_params =
      'start_range=' +
      this.start_range_calendar.format('YYYY-MM-DD') +
      '&end_range=' +
      this.end_range_calendar.format('YYYY-MM-DD') +
      '&guide_id=' +
      this.guideSelected.id;

    this.scheduleService.summaryCalendarByGuide(val_params).subscribe({
      next: (data: any) => {
        this.data_calendar = data.results;
        // datos pasados
        const selectedYear = this.start_range_calendar.year();
        const selectedMonth = this.start_range_calendar.month(); // 0-indexed
        const seriesData = this.generateCalendarHeatmapData(
          this.data_calendar,
          selectedYear,
          selectedMonth
        );
        const titulo =
          'Calendario de Salidas del Mes: ' +
          this.start_range_calendar.format('MMMM YYYY');
        this.updateHeatmapCalendar(seriesData, titulo);
        this.LoadingModalComponent.hide();
      }
    });
  }

  generateGraphicCalendar() {
    const selectedYear = this.start_range_calendar.year();
    const selectedMonth = this.start_range_calendar.month(); // 0-indexed
    this.chartOptionsHeatmap = {
      chart: {
        type: 'heatmap'
        // height: 400
      },
      title: {
        text:
          'Calendario de Tours del Mes ' +
          this.start_range_calendar.format('MMMM YYYY')
      },
      xAxis: {
        categories: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        title: { text: null }
      },
      yAxis: {
        visible: false,
        min: 0,
        max: 5
      },
      tooltip: {
        formatter: function() {
          const point: any = this.point; // <-- aquí está el truco
          return point.value
            ? `<b>${point.nombre}</b><br>Día ${point.dayNumber}`
            : `Día ${point.dayNumber}`;
        }
      },
      // colorAxis: {
      //   min: 0,
      //   max: 1,
      //   minColor: '#FFFFFF',
      //   maxColor: '#00BFFF' // Azul para día con tour
      // },
      series: [
        {
          type: 'heatmap', // ✅ Obligatorio para evitar el error
          name: 'Días de la Semana',
          borderWidth: 1,
          data: this.generateCalendarHeatmapData(
            this.data_calendar,
            selectedYear,
            selectedMonth
          ),
          dataLabels: {
            enabled: true,
            useHTML: true,
            formatter: function() {
              const p: any = this.point;
              if (!p.nombre) return `<span><b>${p.dayNumber}</b></span>`;
              return `<div style="text-align:center">
                        <div style="font-size: 10px"><b>${p.dayNumber}</b></div>
                        <div style="font-size: 10px; margin-top:5px">${p.nombre}</div>
                      </div>`;
            },
            color: '#000',
            style: {
              fontSize: '11px',
              textOutline: 'none'
            }
          }
        } as Highcharts.SeriesHeatmapOptions
      ]
    };
  }

  generateCalendarHeatmapData(data: any[], year: number, month: number): any[] {
    const result: any[] = [];
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Agrupar por fecha en formato DD-MM-YYYY
    const grouped: { [fecha: string]: string[] } = {};

    data.forEach(d => {
      const momentFecha = moment(d.date_departure, 'YYYY-MM-DD');
      const fecha = momentFecha.format('DD-MM-YYYY'); // Convertimos a formato clave
      if (!grouped[fecha]) {
        grouped[fecha] = [];
      }
      grouped[fecha].push(d.description);
    });

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const weekday = date.getDay(); // 0 (Dom) - 6 (Sáb)
      const weekOfMonth = Math.floor(
        (day + new Date(year, month, 1).getDay() - 1) / 7
      );

      const dayStr = `${String(day).padStart(2, '0')}-${String(
        month + 1
      ).padStart(2, '0')}-${year}`;
      const tours = grouped[dayStr] || [];

      result.push({
        x: weekday,
        y: 5 - weekOfMonth, // Para invertir verticalmente
        dayNumber: day,
        nombre: tours.length ? tours.join('<br>') : null,
        value: tours.length ? 1 : null
      });
    }

    return result;
  }

  updateHeatmapCalendar(seriesData: any[], titulo: string) {
    if (this.chartHeatmap) {
      // Eliminar series anteriores
      this.chartHeatmap.series.forEach((serie: Highcharts.Series) => {
        serie.remove(false);
      });

      // Agregar nueva serie heatmap
      this.chartHeatmap.addSeries(
        {
          type: 'heatmap',
          name: 'Días de la Semana',
          borderWidth: 1,
          data: seriesData,
          dataLabels: {
            enabled: true,
            useHTML: true,
            formatter: function() {
              const p: any = this.point;
              if (!p.nombre) return `<span><b>${p.dayNumber}</b></span>`;
              return `<div style="text-align:center">
                        <div style="font-size: 10px"><b>${p.dayNumber}</b></div>
                        <div style="font-size: 10px; margin-top:5px">${p.nombre}</div>
                      </div>`;
            },
            color: '#000',
            style: {
              fontSize: '11px',
              textOutline: 'none'
            }
          }
        } as Highcharts.SeriesHeatmapOptions,
        false
      );

      // Actualiza el título dinámicamente
      this.chartHeatmap.update({
        title: {
          text: titulo
        },
        xAxis: {
          categories: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']
        },
        yAxis: {
          visible: false,
          min: 0,
          max: 5
        },
        tooltip: {
          formatter: function() {
            const point: any = this.point;
            return point.value
              ? `<b>${point.nombre}</b><br>Día ${point.dayNumber}`
              : `Día ${point.dayNumber}`;
          }
        },
        colorAxis: {
          min: 0,
          max: 1,
          minColor: '#FFFFFF',
          maxColor: '#00BFFF'
        }
      });

      this.chartHeatmap.redraw();
      this.LoadingModalComponent.hide();
    }
  }

  resetGraph() {
    if (this.chartHeatmap) {
      // Eliminar todas las series
      while (this.chartHeatmap.series.length > 0) {
        this.chartHeatmap.series[0].remove(false); // Eliminar la primera serie hasta que no haya más
      }

      // Desactivar la leyenda
      this.chartHeatmap.update({
        legend: {
          enabled: false // Desactivar la leyenda
        }
      });

      // Redibujar el gráfico
      this.chartHeatmap.redraw();
    }
  }

  close() {
    setTimeout(() => {
      this.start_range = moment()
        .subtract(8, 'days')
        .startOf('day');
      this.end_range = moment()
        .subtract(1, 'day')
        .startOf('day');
      this.items_tours_grouped = [];
      this.items_transport = [];
      this.resetGraph();
    }, 250);
  }

  // prepareGroupedTours(data: any[]) {
  //   const start = this.start_range.clone();
  //   const end = this.end_range.clone();
  //   const dateMap: { [key: string]: string[] } = {};

  //   console.log(data);

  //   // Agrupar los tours por fecha
  //   data.forEach((item: any) => {
  //     const dateKey = moment(item.date_departure).format('YYYY-MM-DD');
  //     if (!dateMap[dateKey]) {
  //       dateMap[dateKey] = [];
  //     }
  //     dateMap[dateKey].push(item.description);
  //   });

  //   const result: any[] = [];

  //   // Recorrer desde la fecha más reciente hacia atrás
  //   const current = end.clone();
  //   while (current.isSameOrAfter(start)) {
  //     const currentDate = current.format('YYYY-MM-DD');
  //     result.push({
  //       date: currentDate,
  //       descriptions: dateMap[currentDate] ?? ['-']
  //     });
  //     current.subtract(1, 'day');
  //   }

  //   console.log(result);
  //   this.items_tours_grouped = result;
  // }
}
